const Status = {
  CONFIRMADA: 1,
  PENDENTE: 0,
  CANCELADA: -1
};

const StatusLabel = index => ["Cancelada", "Pendente", "Confirmada"][1 + index];

export default {
  Status,
  StatusLabel
};



// WEBPACK FOOTER //
// ./src/modules/admin/constants.js